<div class="referrals-promo-container">
  <mat-table [dataSource]="dataSource" class="referrals-promo-table" matSort>

    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="freeCases">
      <mat-header-cell *matHeaderCellDef>Free Cases</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.freeCases.length }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button mat-stroked-button (click)="selectFreeCase(element)">Select</button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="freeCaseColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: freeCaseColumns;"></mat-row>
  </mat-table>
</div>

